import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const startContentConfigDialogWrapperClass = flex({
	p: "20",
	flexDirection: "column",
	gap: "20",
});

export const inputWrapperClass = flex({
	alignItems: "center",
	gap: "4",
});

export const labelClass = css({
	whiteSpace: "nowrap",
	fontWeight: "[600]",
});

export const inputClass = css({
	flexGrow: "1",
});

export const buttonRowClass = flex({
	gap: "[3]",
});

export const buttonClass = css({
	width: "full",
});
